import React from 'react';
import { CornerUpLeft, X } from 'lucide-react';
import { classNames } from '../../utils/classNames';

export const QuoteBar = ({ text, onClear, className = '' }) => {
  if (!text) return null;

  return (
    <div
      className={classNames(
        'flex items-start gap-2 rounded-t-2xl border-b border-neutral-200/80 bg-neutral-100/90 px-3 py-2.5 text-sm text-neutral-600 dark:border-border dark:bg-white/[0.06] dark:text-muted',
        className
      )}
    >
      <CornerUpLeft size={15} className="mt-0.5 shrink-0 opacity-60" />
      <p className="min-w-0 flex-1 line-clamp-2 text-start leading-6">
        «{text}»
      </p>
      <button
        type="button"
        onClick={onClear}
        className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-neutral-400 transition hover:bg-neutral-200/80 hover:text-neutral-700 dark:hover:bg-neutral-800"
        aria-label="clear quote"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export const QuotedMessagePreview = ({ text, className = '' }) => {
  if (!text) return null;
  return (
    <div className={classNames('mb-1.5 max-w-[85%] text-start', className)}>
      <div className="mb-0.5 text-lg leading-none text-neutral-300 dark:text-neutral-600">”</div>
      <p className="text-sm leading-6 text-neutral-400">«{text}»</p>
    </div>
  );
};
